/** Read complete SSE data lines, including a final line without a newline. */
export async function readAIStream(
  body: ReadableStream<Uint8Array>,
  onEvent: (value: unknown) => boolean | Promise<boolean>,
  onBytes?: () => void,
): Promise<boolean> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  const deliver = async (line: string) => {
    const text = line.trim();
    if (!text.startsWith("data:")) return false;
    const payload = text.slice(5).trim();
    if (payload === "[DONE]") return onEvent({ type: "done" });
    let value: unknown;
    try {
      value = JSON.parse(payload);
    } catch {
      return false;
    }
    // Application callback failures must reach the caller, not disappear as parse errors.
    return onEvent(value);
  };
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        buffer += decoder.decode();
        return buffer.trim() ? await deliver(buffer) : false;
      }
      onBytes?.();
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";
      for (const line of lines) if (await deliver(line)) return true;
    }
  } finally {
    // Terminal events end this consumer even if the network stream remains open.
    void reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
